module.exports = __webpack_public_path__ + "static/media/export.28a04d80.svg";